import * as React from "react";
import { Button, Space, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { SecretTypeTag } from "../../../../components/antd/kindselect/tagRenderers/secretTypeTag";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { CpDescription } from "../../../gvc/testNewForm/CpDescription";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpErrorWarningArrayIcon } from "../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpKindSelect } from "../../../gvc/testNewForm/temp/CpKindSelect";
import { useDrawerContext } from "../../../../components/antd/drawerContext";
import { EmbeddedSecretCreate } from "../../../secret/create/embedded";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { parseLink } from "../../../../utils/linkParser/linkParser";
import { KindSelectState } from "../../../../components/antd/kindselect/KindSelect";

interface Props {}
export const ProviderNGS: React.FC<Props> = () => {
  const { id } = useCpFormContext();
  const drawer = useDrawerContext();
  const ngsSecret = useCpFormValue(`ngs.secret`);

  return (
    <>
      <CardTitle>
        NGS
        <CpErrorWarningArrayIcon names={["ngs"]} />
      </CardTitle>
      <CardContent>
        <CpFormItem>
          <CpLabel name={`ngs.secret`}>NGS Secret</CpLabel>
          <CpDescription>This secret will be used to access your Nats Account</CpDescription>
          <Space.Compact style={{ maxWidth: 600, width: "100%" }}>
            <CpKindSelect
              kind="secret"
              name={`ngs.secret`}
              optionValue="name"
              queries={[{ property: "type", value: "nats-account" }]}
              tagRenderers={[SecretTypeTag] as any}
              className="flex-grow"
            />
            {ngsSecret?.value ? null : (
              <Tooltip title="Create NGS Secret">
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    drawer.setPersistent(
                      `cloudaccount-ngs-create-secret`,
                      "Create NGS Secret",
                      <>
                        <EmbeddedSecretCreate
                          lockedType="nats-account"
                          onCancel={() => drawer.closePersistent()}
                          onDone={(itemLink, item) => {
                            drawer.closePersistent();
                            const { name } = parseLink(itemLink, { useInputCtx: true });
                            const state: KindSelectState = {
                              value: name,
                              link: itemLink,
                              item: item,
                            };
                            formSetValue(id, `ngs.secret`, state);
                          }}
                        />
                      </>,
                      600,
                    );
                  }}
                />
              </Tooltip>
            )}
          </Space.Compact>
          <CpErrorWarning name={`ngs.secret`} />
        </CpFormItem>
      </CardContent>
    </>
  );
};
